const availabilityState = {
  data: []
}

export default availabilityState
